export default __webpack_public_path__ + "static/media/delete.1381132e.svg";